/**
 * Distributors Management Page
 * Admin page for managing distributors
 */

import React from 'react';
import { AdminRoute } from '../../components/auth/AdminRoute';
import Distributors from '../../components/distributors/Distributors';

const DistributorsPage = () => {
  return (
    <AdminRoute>
      <Distributors />
    </AdminRoute>
  );
};

export default DistributorsPage;
